import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import styles from './index.scss'
const cx = classnames.bind(styles)

const NotAvailable = ({ text }) => (
  <div className={cx('not-available-blank')}>
    <div className={cx('not-available-text')}>{text}</div>
  </div>
)

NotAvailable.propTypes = {
  text: PropTypes.string,
}

export default NotAvailable
